module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/cloudy-night-1de98b1cae9227825638d7ea183c37d9.svg";